import "./Loader.scss";
import React from "react";

type Props = {
  active?: boolean;
  center?: boolean;
  size?: "lg" | "md" | "sm";
};

export default function Loader({ active, center, size = "md" }: Props) {
  const loaderEl = (
    <div
      className={`loader loader--${size}${active ? " loader--active" : ""}`}
    />
  );

  return center ? (
    <div className="fade-in flex justify-center">{loaderEl}</div>
  ) : (
    loaderEl
  );
}

Loader.defaultProps = {
  active: true,
  center: false,
  size: "md",
};
